const warehouses = [
  { id: '1', code: '1', name: 'Catalogue' }, // BLACK
  { id: '2', code: '2', name: 'Off season' }, // RED
  { id: '3', code: '3', name: 'In season' }, // BLUE
];

export { warehouses };
